import React, { useMemo } from 'react';
import queryParams from 'query-string';

export const useQueryParams = ({ location, history }) => {
	const { search } = location;

	const query = useMemo(() => queryParams.parse(search), [search]);

	/**
	 * Set multiple query params to the URL at once
	 *
	 * @param {[{ name, value }]} params array of query param objects with name and value
	 */
	const setParams = (params) => {
		const parsedParams = params.reduce((acc, { name, value }) => {
			// if value is empty, remove the param from the URL
			if (!value || !value?.length) {
				delete query[name];
				delete acc[name];
				return acc;
			}

			acc[name] = value;
			return acc;
		}, {});

		const groupedParams = new URLSearchParams({ ...query, ...parsedParams });

		history.replace({ pathname: location.pathname, search: groupedParams.toString() });
	}

	return {
		query,
		setParams
	}
}